import { forwardRef } from 'react';
import { Textarea, FormErrorMessage } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const TextAreaField = forwardRef(
    ({ field, form, walkthroughid, rows = 3, ...props }, ref) => {
        const { darkMode } = useSelector((state) => state.settings);
        const { touched, errors } = form;
        const isInvalid = touched[field.name] && errors[field.name];

        return (
            <>
                <Textarea
                    {...field}
                    {...props}
                    ref={ref}
                    bg={darkMode ? '#1e2021' : 'white'}
                    color={darkMode ? 'white' : 'black'}
                    borderColor={darkMode ? 'gray.600' : 'gray.300'}
                    borderRadius="md"
                    size="md"
                    rows={rows}
                    resize="none"
                    padding="2px 6px"
                    _focus={{
                        borderColor: 'messenger.500',
                        boxShadow: '0 0 0 1px #3182ce',
                    }}
                    data-walkthroughid={walkthroughid}
                    isInvalid={isInvalid}
                />
                {isInvalid && (
                    <FormErrorMessage fontSize="sm">
                        {errors[field.name]}
                    </FormErrorMessage>
                )}
            </>
        );
    },
);

TextAreaField.displayName = 'TextAreaField';

export default TextAreaField;
